import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { DashboardResourceService } from "libraries/service/resources/dashboard/dashboard-resource.service";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import { GenericGraph } from "../generic-graph/generic-graph.directive";
import { Wording } from "app_dashboard/pages/dashboard/dashboard-page.component";
import { NotificationType } from "libraries/interfaces/INotification";
import { LocalizedPipe } from "libraries/pipes/localized/localized.pipe";

@Component({
    selector: 'sunburst-graph',
    template: `
        <notification [type]="notificationType" *ngIf="displayError">
            {{error}}
        </notification>
        <div [id]="id" class="full">

        </div>
    `,
    styles: [`
        .full {
            width: 100%;
            height: 100%;
        }
    `],
})
export class SunburstGraphComponent extends GenericGraph implements OnInit, AfterViewInit, OnDestroy {

    private wording: Wording = new Wording();

    constructor(
        public searchParameterService: SearchParameterService,
        public dashboardResource: DashboardResourceService,
        public localizedPipe : LocalizedPipe
    ) {
        super(searchParameterService, dashboardResource, localizedPipe);
    }

    protected draw(data: any): void {
        if (data.series) {
            let option = {
                series: data.series,
                tooltip: {
                    trigger: 'item',
                    formatter: (params) => {
                        const round: string = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>`;
                        if (params.treePathInfo && params.treePathInfo.length >= 2) {
                            const val: number = (params.value / params.treePathInfo[params.treePathInfo.length - 2].value) * 100;
                            return (`${round} ${params.name} <br\> <strong>${params.value}</strong> (${val.toFixed(2)} %)`);
                        }
                    }
                },
                title: {
                    text: this.title,
                    textStyle: {
                        fontSize: 15,
                    },
                },
            };
            this.chart.setOption(option);
        } else {
            this.chart.clear();
            this.displayError = true;
            this.notificationType = NotificationType.Info;
            this.error = this.wording.noData;
        }
    }

}
